import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import {eventsModalstoggleVisibilitySlice} from "../../slices/eventsModalstoggleVisibilitySlice";
import {StatusCodesServer} from "../../hooks";
import {RootState} from "../../store";
import GeneralUtils from "../../../utils/GeneralUtils";

export interface Post {
    email: string;
    password: string;
}

export const favoriteServiceApi = createApi({
    reducerPath: 'FavoriteServiceApi',
    baseQuery: fetchBaseQuery({
        baseUrl: GeneralUtils.getEnvironment(window.location.origin),
        prepareHeaders: (headers, { getState }) => {
            const token = (getState() as RootState).authSlice.accountInformation.token;
            if (token) {
                headers.set('authorization', `Bearer ${token}`);
            }
            return headers;
        }
    }),
    endpoints: builder => ({
        addFavorite: builder.mutation<any, any>({
            query: (Favorite) => ({
                url: '/favorite/',
                method: 'POST',
                body: Favorite,
                headers: {
                    authorization:
                        'Bearer ' + JSON.parse(localStorage.getItem('accountInformation') || '{}').token
                }
            }),
            async onQueryStarted(_undefined, { dispatch, queryFulfilled }) {
                try {
                    dispatch(
                        eventsModalstoggleVisibilitySlice.actions.toggleVisibilityLoadingWidget(true)
                    );
                    await queryFulfilled;
                    StatusCodesServer(dispatch, 200);
                } catch (err: any) {
                    StatusCodesServer(dispatch, err.error.status);
                } finally {
                    dispatch(
                        eventsModalstoggleVisibilitySlice.actions.toggleVisibilityLoadingWidget(false)
                    );
                }
            }
        }),
        deleteFavorite: builder.mutation<any, any>({
            query: (Favorite) => ({
                url: '/favorite/',
                method: 'DELETE',
                body: Favorite,
                headers: {
                    authorization:
                        'Bearer ' + JSON.parse(localStorage.getItem('accountInformation') || '{}').token
                }
            }),
            async onQueryStarted(_undefined, { dispatch, queryFulfilled }) {
                try {
                    dispatch(
                        eventsModalstoggleVisibilitySlice.actions.toggleVisibilityLoadingWidget(true)
                    );
                    await queryFulfilled;
                    StatusCodesServer(dispatch, 200);
                } catch (err: any) {
                    StatusCodesServer(dispatch, err.error.status);
                } finally {
                    dispatch(
                        eventsModalstoggleVisibilitySlice.actions.toggleVisibilityLoadingWidget(false)
                    );
                }
            }
        }),
        editFavorite: builder.mutation<any, any>({
            query: (Favorite) => ({
                url: '/favorite/',
                method: 'PUT',
                body: Favorite,
                headers: {
                    authorization:
                        'Bearer ' + JSON.parse(localStorage.getItem('accountInformation') || '{}').token
                }
            }),
            async onQueryStarted(_undefined, { dispatch, queryFulfilled }) {
                try {
                    dispatch(
                        eventsModalstoggleVisibilitySlice.actions.toggleVisibilityLoadingWidget(true)
                    );
                    await queryFulfilled;
                    StatusCodesServer(dispatch, 200);
                } catch (err: any) {
                    StatusCodesServer(dispatch, err.error.status);
                } finally {
                    dispatch(
                        eventsModalstoggleVisibilitySlice.actions.toggleVisibilityLoadingWidget(false)
                    );
                }
            }
        }),
        editSortFavoriteDirections: builder.mutation<any, any>({
            query: (body) => ({
                url: '/favorite/directions-order',
                method: 'PUT',
                body: body,
                headers: {
                    authorization:
                        'Bearer ' + JSON.parse(localStorage.getItem('accountInformation') || '{}').token
                }
            }),
            async onQueryStarted(_undefined, { dispatch, queryFulfilled }) {
                try {
                    dispatch(
                        eventsModalstoggleVisibilitySlice.actions.toggleVisibilityLoadingWidget(true)
                    );
                    await queryFulfilled;
                    StatusCodesServer(dispatch, 200);
                } catch (err: any) {
                    StatusCodesServer(dispatch, err.error.status);
                } finally {
                    dispatch(
                        eventsModalstoggleVisibilitySlice.actions.toggleVisibilityLoadingWidget(false)
                    );
                }
            }
        }),
        getFavorites: builder.query<any, void>({
            query: () => ({
                url: '/favorite/',
                headers: {
                    authorization:
                        'Bearer ' + JSON.parse(localStorage.getItem('accountInformation') || '{}').token
                }
            }),
            async onQueryStarted(_undefined, { dispatch, queryFulfilled }) {
                try {
                    dispatch(
                        eventsModalstoggleVisibilitySlice.actions.toggleVisibilityLoadingWidget(true)
                    );
                    await queryFulfilled;
                    StatusCodesServer(dispatch, 200);
                } catch (err: any) {
                    StatusCodesServer(dispatch, err.error.status);
                } finally {
                    dispatch(
                        eventsModalstoggleVisibilitySlice.actions.toggleVisibilityLoadingWidget(false)
                    );
                }
            }
        }),
        getFiltersNewsAlerts: builder.query<any, void>({
            query: () => ({
                url: '/favorite/newsFilter',
                headers: {
                    authorization:
                        'Bearer ' + JSON.parse(localStorage.getItem('accountInformation') || '{}').token
                }
            }),
            transformResponse: (response: any) => {
                return {
                    ...response,
                }
            }
        }),
        editFiltersNewsAlerts: builder.mutation<any, any>({
            query: (body) => ({
                url: '/favorite/newsFilter',
                method: 'PUT',
                body: body,
                headers: {
                    authorization:
                        'Bearer ' + JSON.parse(localStorage.getItem('accountInformation') || '{}').token
                }
            }),
        }),
    }),
});

export const {
    useAddFavoriteMutation,
    useDeleteFavoriteMutation,
    useGetFavoritesQuery,
    useLazyGetFavoritesQuery,
    useEditFavoriteMutation,
    useLazyGetFiltersNewsAlertsQuery,
    useEditFiltersNewsAlertsMutation,
    useEditSortFavoriteDirectionsMutation,
} = favoriteServiceApi;
